export default __webpack_public_path__ + "static/media/landing.c2c756af.webp";